import UltMeta, {Meta} from './UltMeta/index';

/**
 * 税率
 */
class TaxRate extends UltMeta {
    THREE = new Meta(1, "3%", 0.03);
    SIX = new Meta(2, "6%", 0.06);
    NINE = new Meta(3, "9%", 0.09);
    THIRTEEN = new Meta(4, "13%", 0.13);
}

export const TAX_RATE = new TaxRate();

/**
 * 浮动方式
 */
class FloatType extends UltMeta {
    FLOAT_RATIO = new Meta(1, "浮动比例");
    FLOAT_TON = new Meta(2, "浮动固定吨数");
}

export const FLOAT_TYPE = new FloatType();

/**
 * 结算方式
 */
class SettlementMethod extends UltMeta {
    FULL_PAYMENT = new Meta(1, "全部货款");
    PAY_DEPOSIT = new Meta(2, "支付定金");
}

export const SETTLEMENT_METHOD = new SettlementMethod();

/**
 * 支付定金方式
 */
class DepositPaymentMethod extends UltMeta {
    PAYMENT_RATIO = new Meta(1, "货款比例");
    FIXED_AMOUNT = new Meta(2, "固定金额");
}

export const DEPOSIT_PAYMENT_METHOD = new DepositPaymentMethod();

/**
 * 商品状态
 */
class State extends UltMeta {
    UP_SHELF = new Meta(1, "上架");
    DOWN_SHELF = new Meta(2, "下架");
}

export const STATE = new State();

/**
 * 发布状态
 */
class PublishState extends UltMeta {
    PENDING = new Meta(6, "待提交");
    NOT_AUDIT = new Meta(1, "待审核");
    FAIL = new Meta(2, "未通过");
    PASS = new Meta(3, "已发布");
    DOWN_SHELF = new Meta(4, "已下架");
    CLOSE = new Meta(5, "已关闭");
}

export const PUBLISH_STATE = new PublishState();

/**
 * 团购状态
 */
class GroupPurchaseState extends UltMeta {
    GROUPING = new Meta(1, "拼团中");
    SUCCESS = new Meta(2, "拼团成功");
    FAIL = new Meta(3, "拼团失败");
}

export const GROUP_PURCHASE_STATE = new GroupPurchaseState();
